import React from "react";
import { API_ROUTE } from "../../../../const/apiRoute";
import Repository from "../../../../_base/helper/HttpHelper";
import { MessageResponse } from "../../../../model/MessageResponse";
import { Box, Button, Group, Text } from "@mantine/core";
import { modals } from "@mantine/modals";
import { IconCheck, IconX } from "@tabler/icons-react";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";

const DeleteProductSelected = ({ idItems, idFbAds, onClose, fetchDataList }: DeleteProduct) => {
  const handleDelete = async () => {
    const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);
    const res = await repository.post<MessageResponse<boolean>>(
      `${API_ROUTE.DELETE_PRODUCT_SELECTED}`,
      {
        "fbAdsId": idFbAds,
        "ids": idItems
      }
    );
    if (res)
      if (res.success) {
        NotificationExtension.Success("Xóa thành công !");
        fetchDataList()
        onClose((prev: any) => !prev);
      } else NotificationExtension.Fails("Xóa thất bại !");
    modals.closeAll();
  };
  return (
    <Box size={"auto"}>
      <Text size="20px" mt={5}>
        Bạn có chắc chắn muốn xóa những sản phẩm này ?
      </Text>
      <Group justify="center" mt="lg">
        <Button
          type="button"
          color="gray"
          onClick={() => modals.closeAll()}
          leftSection={<IconX size={18} />}
        >
          Hủy
        </Button>
        <Button
          type="button"
          color="red"
          onClick={handleDelete}
          leftSection={<IconCheck size={18} />}
        >
          Xóa
        </Button>
      </Group>
    </Box>
  );
};
type DeleteProduct = {
  idItems: (number | string)[];
  idFbAds: (number | string)
  onClose: any;
  fetchDataList: ()=>void
};
export default DeleteProductSelected;
